// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"MarkdownRender_paragraph__0QV3s","heading":"MarkdownRender_heading__py9Nq","h1":"MarkdownRender_h1__iBIjh"};